export default {
  state: {
    activeSystemTaskExecutionId: null,
  },
  mutations: {
    set_active_system_task_execution_id(state, id) {
      state.activeSystemTaskExecutionId = id;
    },
  },
  actions: {
    startSystemTaskExecutionProgress({commit}, id) {
      commit('set_active_system_task_execution_id', id);
    },
    clearSystemTaskExecutionProgress({commit}) {
      commit('set_active_system_task_execution_id', null);
    },
  },
  getters: {
    activeSystemTaskExecutionId: (state) => state.activeSystemTaskExecutionId,
  },
};